export default "__VITE_ASSET__x3POga8U__"